export default "__VITE_ASSET__BO8JK23c__"